<!--Conteneur principal affiché une fois la règle chargée-->
<div class="content" *ngIf="regleAttribution">
    <!--En-tête de page avec titre, navigation retour et gestion des onglets-->
    <page-header [title]="getTitle()"
                 (onSelectedItemChange)="onSelectedItemChange($event)"
                 (onGoBack)="onGoBack()"
                 [listeItems]="listeTabItems">
    </page-header>

    <!--Contenu de l'onglet Généralités-->
    <div [hidden]="selectedItem?.code !== Onglets.GENERALITES">
        <!--Formulaire du détail règle d'attribution-->
        <form #form="ngForm">
            <!--Composant enfant portant les champs de saisie des généralités-->
            <indemnites-regle-attribution-generalites
                [regleAttribution]="regleAttribution">
            </indemnites-regle-attribution-generalites>

            <!--Bloc des prestations associées visible uniquement en mode édition-->
            <fieldset ngModelGroup="regle-attribution-prestations" *ngIf="!isCreation">
                <mat-card class="prestations-card p-0">
                    <mat-card-content>
                        <div class="listview">
                            <list-view-search class="listview-search" [liste]="listeViewEntetePrestations"></list-view-search>

                            <div class="listview-body" *ngIf="listeReglesPrestas.length > 0; else listePrestationsVide">
                                <div class="listview-item" *ngFor="let reglePresta of listeReglesPrestas" data-test-id="regle-attribution-prestation-item">
                                    <div class="list-view-item-hover">
                                        <div class="lvi-content">
                                            <div class="avatar">
                                                <i class="nio icon-frais"></i>
                                            </div>
                                            <div class="lvi-body">
                                                <div class="title">
                                                    <a class="label">{{ reglePresta?.prestation?.libelle || '-' }}</a>
                                                </div>
                                                <ul class="lvi-attrs">
                                                    <li><strong>{{ 'admin.frais.indemnites.reglesAttribution.detail.prestations.colonnes.domaine' | translate }}</strong>{{ reglePresta?.prestation?.domainePrestation || '-' }}</li>
                                                    <li><strong>{{ 'admin.frais.indemnites.reglesAttribution.detail.prestations.colonnes.type' | translate }}</strong>{{ getTypePrestationLabel(reglePresta) }}</li>
                                                    <li><strong>{{ 'admin.frais.indemnites.reglesAttribution.detail.prestations.colonnes.quantite' | translate }}</strong>{{ reglePresta?.qte | number: '1.2-2' }}</li>
                                                    <li><strong>{{ 'admin.frais.indemnites.reglesAttribution.detail.prestations.colonnes.actif' | translate }}</strong>{{ getActifLabel(reglePresta) }}</li>
                                                </ul>
                                            </div>
                                            <div class="lvi-actions">
                                                <button mat-icon-button
                                                        type="button"
                                                        (click)="onDeletePrestation(reglePresta)"
                                                        [matTooltip]="'global.actions.supprimer' | translate">
                                                    <i class="nio icon-suppression"></i>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <ng-template #listePrestationsVide>
                                <div class="listview-body">
                                    <div class="empty text-muted prestations-empty">
                                        <span [translate]="'admin.frais.indemnites.reglesAttribution.detail.prestations.listeVide'"></span>
                                    </div>
                                </div>
                            </ng-template>
                        </div>
                    </mat-card-content>
                </mat-card>
            </fieldset>
        </form>
    </div>

    <!--Bouton flottant pour les actions Enregistrer/Supprimer-->
    <floating-button [listeActions]="listeActions" [isPending]="isSaving"></floating-button>
</div>

<!--Indicateur de chargement tant que les données ne sont pas disponibles-->
<please-wait class="content" *ngIf="isLoading && !regleAttribution"></please-wait>
